if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
    window.process = { env: {} };
}

if (typeof window !== 'undefined' && typeof window.global === 'undefined') {
    window.global = window;
}
